export default __webpack_public_path__ + "static/media/whittle-logo.7a000fd5.png";